import { getService } from 'data/function';
export class SegmentProcessor {
    static get SegmentService() {
        return getService('SegmentService');
    }
    static process({ message }) {
        switch (message.content.method) {
            case 'createTrack':
                this.SegmentService.createTrack(message.content.parameters.trackEvent, message.content.parameters.payload);
                break;
            case 'createApplicationTrack':
                this.SegmentService.createApplicationTrack({
                    trackEvent: message.content.parameters.trackEvent,
                    payload: message.content.parameters.payload,
                    application: message.content.parameters.application,
                });
                break;
            case 'resetAccount':
                this.SegmentService.resetAccount();
                break;
            case 'setAccount':
                this.SegmentService.resetAccount();
                break;
            case 'createApplicationTrack':
                this.SegmentService.createApplicationTrack(message.content.parameters);
                break;
            case 'createOrganizationTrack':
                this.SegmentService.createOrganizationTrack(message.content.parameters.trackEvent, message.content.parameters.payload);
                break;
            default:
                throw new Error('Unrecognized segment method: method');
        }
    }
}
